import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import ComparisonCard from "../components/ComparisonCard";
import FeatureCard from "../components/FeatureCard";
import TinySlider from "tiny-slider-react";
import Clients from "../components/clients";
import VideoBackground from "../components/VideoBackground";
import CardBeneficios from "../components/CardBeneficios";
import ba from "../assets/images/sidom/svg/Ar.svg";
import img from "../assets/images/sidom/fotos/SIDOM-LOGO-NEGRO.png";
import useStore from "../store/useStore";

const settings = {
  container: ".tiny-one-item",
  items: 4,
  controls: true,
  mouseDrag: true,
  loop: true,
  rewind: true,
  animateOut: "rollOut",
  autoplay: false,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: "bottom",
  controlsText: [
    '<i class="mdi mdi-chevron-left "></i>',
    '<i class="mdi mdi-chevron-right"></i>',
  ],
  nav: true,
  speed: 1000,
  gutter: 20,
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1024: {
      items: 4,
    },
  },
};
const productos = [
  {
    title: "Elimine tiempos de conexión y desconexión",
    description:
      "en distintos sistemas centralizando en una única plataforma todas las herramientas de uso diario.",
  },
  {
    title: "Aumente la productividad validando y oficializando",
    description:
      "varias destinaciones aduaneras al mismo tiempo, en distintas aduanas y de forma autónoma.",
  },
  {
    title: "Automatice las presentaciones",
    description: "de documentos o validaciones AFIP desde la plataforma.",
  },
  {
    title: "Acceda en tiempo real a las declaraciones aduaneras",
    description:
      "Podrá acceder a la información en tiempo real de sus declaraciones aduaneras sin límites de usuarios.",
  },
  {
    title: "Tenga visibilidad 360° de todas las operaciones",
    description:
      "Tenga visibildad de todas sus operaciones y sus movimeintos desde cualquier dispositivo y lugar.",
  },
  {
    title: "Obtenga reportes automáticos personalizables",
    description:
      "Envíe reportes automáticos personalizables sobre vencimientos, saldos y estados de las operaciones.",
  },
];
const features = [
  {
    title: "MOA",
    description:
      "Visualice el estado de reintegros de exportación, canales, cumplidos, liberación a plaza con interfaz MOA y AFIP, con información 100% actualizada en línea.",
    items: [
      "Seguimiento de reposición de stock.",
      "Seguimiento de reintegros con actualización en línea.",
      "Seguimiento de garantías con actualización desde AFIP.",
    ],
  },
  {
    title: "Drive",
    description:
      "Guarde documentos importantes como emails, comprobantes, facturas de terceros y archivos de los embarques para tener un rápido acceso a los mismos.",
    items: [
      "Guarde y visualice documentación técnica de los productos de catálogo.",
      "Envíe por email los documentos relacionados a los embarques y sus artículos.",
    ],
  },
  {
    title: "Info",
    description: "Integración con información oficial de consulta diaria.",
    items: [
      "Tipos de cambio e históricos actualizados online.",
      "Entrada de buques a todas las terminales.",
      "Estados de pasos fronterizos.",
      "Fob oficiales.",
      "Incoterms.",
      "Tipos de contenedores y sus medidas.",
    ],
  },
  {
    title: "MiSIM",
    description:
      "Es el único RPA creado para la automatización y eficientización del proceso de declaraciones aduaneras.",
    items: [
      "Permite operar de manera tecnológica y eficiente.",
      "Automatiza las oficializaciones de las destinaciones aduaneras desde internet.",
    ],
  },
  {
    title: "MOA",
    description:
      "Visualice el estado de reintegros de exportación, canales, cumplidos, liberación a plaza con interfaz MOA y AFIP, con información 100% actualizada en línea.",
    items: [
      "Seguimiento de reposición de stock.",
      "Seguimiento de reintegros con actualización en línea.",
      "Seguimiento de garantías con actualización desde AFIP.",
    ],
  },
  {
    title: "Drive",
    description:
      "Guarde documentos importantes como emails, comprobantes, facturas de terceros y archivos de los embarques para tener un rápido acceso a los mismos.",
    items: [
      "Guarde y visualice documentación técnica de los productos de catálogo.",
      "Envíe por email los documentos relacionados a los embarques y sus artículos.",
    ],
  },
  {
    title: "Info",
    description: "Integración con información oficial de consulta diaria.",
    items: [
      "Tipos de cambio e históricos actualizados online.",
      "Entrada de buques a todas las terminales.",
      "Estados de pasos fronterizos.",
      "Fob oficiales.",
      "Incoterms.",
      "Tipos de contenedores y sus medidas.",
    ],
  },
  {
    title: "MiSIM",
    description:
      "Es el único RPA creado para la automatización y eficientización del proceso de declaraciones aduaneras.",
    items: [
      "Permite operar de manera tecnológica y eficiente.",
      "Automatiza las oficializaciones de las destinaciones aduaneras desde internet.",
    ],
  },
];
export default function Misim() {
  const { misimHeroes, getMisimHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getMisimHeroes();
  }, [getMisimHeroes]);

  return (
    <div className="bg-sidom-light dark:bg-sidom-blue">
      <Navbar />
      <div>
        {misimHeroes?.length === 0 || !misimHeroes ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
          />
        ) : (
          misimHeroes.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              logo={`${urlApi}${
                item.img[0]?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
              cartel={
                <div className="flex flex-row justify-start items-center text-2xl text-sidom-light mb-8">
                  <p>Solo disponible en Argentina</p>
                  <img src={ba} alt="AR" className="ml-2 w-10 h-5" />
                </div>
              }
            />
          ))
        )}
      </div>
      <div className="w-full aspect-video max-h-[900px] ">
        <video
          controls
          autoPlay
          muted
          loop
          className="w-full h-full object-cover aspect-video shadow-md"
        >
          <source
            src="https://api.institucional.global.sidom.io/uploads/misim_web2_774c05790c.mp4"
            type="video/webm"
          />
        </video>
      </div>
      <div className="container mt-[60px] ">
        <h2 className="text-left text-wrap text-xl text-sidom-dark dark:text-sidom-light leading-[1.3]">
          <strong>SIDOM MISIM</strong> es la solución de tecnología y comercio
          exterior más elegida en el mercado para la gestión de estudios
          aduaneros. Permite resolver las principales dificultades operativas a
          partir de la aplicación de tecnología IA y RPA. Toda la gestión se
          realiza en remoto desde cualquier lugar del país, sin necesidad de
          disponer de terminales físicas exclusivas para Malvina.
        </h2>
      </div>
      <div className="container mt-[100px] mb-[100px]">
        <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold text-left  mb-[100px]">
          Comparación de la plataforma
        </h2>
        <div>
          <div className="container grid grid-cols-1 md:grid-cols-2 gap-16 mt-[60px]">
            <ComparisonCard
              title="Única plataforma 100% Cloud del mercado"
              description="Accede a tus datos desde cualquier lugar y colabora sin límites con SIDOM. Nuestra plataforma en la nube garantiza flexibilidad y eficiencia para tu equipo."
              backgroundColor="bg-sidom-orange"
              textColor="text-sidom-dark"
              iconSrc="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/sidom3d.png"
              img={img}
            />
            <ComparisonCard
              title="Otros"
              description="Otros players del mercado tienen encubierta una solución hosteada donde es necesario conectarse a través de Citrix o terminal server, teniendo costos asociados para el cliente."
              backgroundColor="bg-sidom-blue border  dark:border-sidom-orange"
              textColor="text-sidom-light"
            />
          </div>
        </div>
      </div>
      <div className="container mt-[100px] mb-[100px]">
        <div className="flex flex-col h-full">
          <h2 className="text-sidom-orange mt-[100px]  mb-[60px] text-4xl md:text-5xl font-extrabold text-left ">
            Beneficios
          </h2>
          {productos.map((producto, index) => (
            <CardBeneficios
              key={index}
              titulo={producto.title}
              descripcion={producto.description}
            />
          ))}
        </div>
      </div>
      <div className="container mb-[40px] flex flex-col justify-start">
        <h5 className="text-2xl md:text-3xl text-left  mt-[100px] lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-orange  dark:text-sidom-light mb-8">
          Soluciones integradas 4.0
        </h5>
        <p className="text-left mb-6 max-w-3xl">
          Reemplace la tecnología que limita el negocio por la plataforma de
          próxima generación diseñada para aprovechar machine learning y la
          inteligencia artificial.
        </p>
      </div>
      <div className="mb-[80px]">
        <div className="container relative">
          <div className="tiny-one-item">
            <TinySlider settings={settings}>
              {features.map((feature, index) => (
                <div key={index}>
                  <FeatureCard
                    title={feature.title}
                    description={feature.description}
                    items={feature.items}
                  />
                </div>
              ))}
            </TinySlider>
          </div>
        </div>
      </div>{" "}
      <div className="mt-[60px] mb-[80px]">
        <Clients />
      </div>
      <Footer />
      <Switcher />
    </div>
  );
}
